import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

export class MailChannelForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet) {

    const view = this.viewGet();
    viewSet.viewAdd(view);
  }

  private viewGet(): CerFormView {
    const view = new CerFormView();

    view.viewMetadata = {
      name: 'mailChannels', dataApiName: 'MailChannel', text: 'Udgående mail kanaler',
      primaryKey: 'id', titleFields: ['name'], allowEdit: true, allowCreate: true, allowDelete: true, baseFields: ['history']
    };

    view.fieldMetadata =
      [{ name: 'id', text: 'Id', tooltipText: 'Unik nøgle for kanalen', allowEdit: false, visible: false, widthType: FieldWidthEnum.XS },
      { name: 'name', text: 'Navn', tooltipText: 'Navn (reference til teknisk opsætning)', widthType: FieldWidthEnum.M, orderBy: 'Ascending' },
      { name: 'active', text: 'Aktiv', tooltipText: 'Er kanalen aktiv?', format: 'CheckBox' },
      ];

    return view;
  }
}
